import { ProFormaModelIds } from 'constants/proForma';
import { useAuthContext } from 'contexts/AuthContext';

interface AssetType {
    id: number;
    name: string;
}

interface AssetTypeDropdownOption {
    value: string;
    label: string;
    disabled?: boolean;
    disabledTooltip?: string;
}

const useAssetTypeDropdownOptions = (assetTypes: AssetType[]) => {
    const { user } = useAuthContext();
    const isNorthspyreUser: boolean = !!user?.email?.toLowerCase().endsWith('@northspyre.com');

    const capitalizeFirstLetter = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

    const getAssetTypeDisabledProps = (assetTypeId: number) => {
        switch (assetTypeId) {
            case ProFormaModelIds.LAND_DEVELOPMENT:
                return !isNorthspyreUser ? { disabled: true, disabledTooltip: 'Coming in Q2!' } : {};
            case ProFormaModelIds.SELF_STORAGE:
            case ProFormaModelIds.RESIDENTIAL_CONDO:
            case ProFormaModelIds.HOTEL_HOSPITALITY:
                return !isNorthspyreUser ? { disabled: true, disabledTooltip: 'Coming soon!' } : {};
            default:
                return {};
        }
    };

    return assetTypes?.map((assetType: AssetType): AssetTypeDropdownOption => ({
        value: String(assetType.id),
        label: capitalizeFirstLetter(assetType.name),
        ...getAssetTypeDisabledProps(assetType.id),
    })) || [];
};

export default useAssetTypeDropdownOptions;